import React from 'react';
import "./onboard-link-style.scss";
import {ReactComponent as LinkIcon} from './images/link.svg';

const OnboardLink = (props) => {

    const {onClick, big, label, icon} = props;

    return (
        <div className="onboard-link-root">
            <button onClick={() => onClick()}
                    className={"onboard-link " + (big ? 'onboard-link-big-text' : '')}>{label}</button>
            {icon && <LinkIcon className="onboard-link-icon"/>}
        </div>
    )
};

export default OnboardLink;
